import { defineStore } from 'pinia'
import { ref } from 'vue'

import { customizeStorage } from '../storage/customizeStorage'

export type CustomizeCache = Record<string, Record<string, unknown>>

/** Small report-owned UI cache with the legacy store id, key nesting and secure-ls codec. */
export const useCustomizeStore = defineStore(
  'customizeStore',
  () => {
    const cache = ref<CustomizeCache>({})
    const apiConfigs = ref<Record<string, unknown>>({})

    function getCached<T>(partition: string, kind: string): T | undefined {
      return cache.value[partition]?.[kind] as T | undefined
    }

    function setCached<T>(partition: string, kind: string, value: T): void {
      cache.value = {
        ...cache.value,
        [partition]: { ...(cache.value[partition] ?? {}), [kind]: value },
      }
    }

    function resetState(): void {
      cache.value = {}
      apiConfigs.value = {}
    }

    return { cache, apiConfigs, getCached, setCached, resetState }
  },
  {
    persist: {
      key: 'customizeStore',
      storage: customizeStorage,
    },
  },
)
